/**
 * Session expiry (HTTP 401) is expected after SESSION_COOKIE_AGE.
 * Reload the SPA instead of rejecting, so Axios callers do not surface
 * unhandled rejections in Sentry (JAVASCRIPT-VUE-8R).
 */

let reloadStarted = false;

/**
 * @param {unknown} error
 * @returns {boolean}
 */
export function isUnauthorizedError(error) {
    if (!error || typeof error !== "object") {
        return false;
    }
    if (error.response && error.response.status === 401) {
        return true;
    }
    return error.success === false && error.code === 401;
}

/**
 * @param {{ exception?: { values?: Array<{ value?: string }> }, message?: string }} [event]
 * @returns {string}
 */
function sentryEventMessage(event) {
    const exceptionValue = event?.exception?.values?.[0]?.value;
    return event?.message || exceptionValue || "";
}

/**
 * @param {{ exception?: { values?: Array<{ value?: string }> }, message?: string }} [event]
 * @param {{ originalException?: unknown }} [hint]
 * @returns {boolean}
 */
export function isUnauthorizedSentryEvent(event, hint) {
    if (isUnauthorizedError(hint?.originalException)) {
        return true;
    }
    const message = sentryEventMessage(event);
    return typeof message === "string" && message.includes("status code 401");
}

/**
 * @param {{ location?: { reload: () => void } }} [target]
 * @returns {Promise<never>}
 */
export function handleUnauthorizedSession(target) {
    const reloadTarget = target || (typeof window !== "undefined" ? window : undefined);
    if (!reloadStarted) {
        reloadStarted = true;
        if (typeof reloadTarget?.location?.reload === "function") {
            reloadTarget.location.reload();
        }
    }
    return new Promise(() => {});
}

/** Reset the one-shot reload guard. Tests only. */
export function resetUnauthorizedSessionHandler() {
    reloadStarted = false;
}
